export default "__VITE_ASSET__ClW$2E$d__"